import PropTypes from "prop-types";
import { createRef, useEffect, useState } from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
// material
import { styled } from "@mui/material/styles";
import { Box, Link, Drawer, Typography, Avatar, IconButton } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
// components
import Logo from "../../components/Logo";
import Scrollbar from "../../components/table/Scrollbar";
import NavSection from "../../components/NavBar";
import { MHidden } from "../../components/@material-extend";
import { parseEmail } from "../../utils/tableFunctions";
import { APP_USER_SESSION } from "../../constant/AppConstants";
import sidebarConfig from "./SidebarConfig";
import * as StorageUtils from "../../utils/storageUtils";
import { prefixV3 } from "../../utils/constants";

// ----------------------------------------------------------------------

const DRAWER_WIDTH = 280;

const RootStyle = styled("div")(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    flexShrink: 0,
  },
}));

const AccountStyle = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(2, 2.5),
  borderRadius: theme.shape.borderRadiusSm,
  backgroundColor: theme.palette.grey[200],
}));

// ----------------------------------------------------------------------

DashboardSidebar.propTypes = {
  isOpenSidebar: PropTypes.bool,
  onCloseSidebar: PropTypes.func,
};

export default function DashboardSidebar({ isOpenSidebar, onCloseSidebar, hidden }) {
  const { pathname } = useLocation();
  const [isCollapsibleMenu, setIsCollapsibleMenu] = useState(false)
  const ref = createRef()

  let userSession = StorageUtils.getParsedValue(APP_USER_SESSION);

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
  }, [pathname]);

  useEffect(() => {
  }, [])

  const mouseLeaveAndOver = (e) => {
    if (isCollapsibleMenu) {
      const currentRef = ref.current
      const collapseSidebar = "collapse-sidebar"
      if (e.type === 'mouseover' && currentRef.classList.contains(collapseSidebar)) {
        currentRef.classList.remove(collapseSidebar)
      } else if (e.type !== 'mouseover' && !currentRef.classList.contains(collapseSidebar)) {
        currentRef.classList.add(collapseSidebar)
      }
    }
  }

  const handleCollapseMenu = () => {
    setIsCollapsibleMenu(!isCollapsibleMenu)
  }

  const userEntity = userSession?.oxygen7_entity || null;
  console.log('[DashboardSidebar] Current userEntity:', userEntity);

  const filterNavItems = (items) => {
    if (!items) return items;
    return items
      .filter(item => {
        if (item.restrictedTo) {
          if (!userEntity) return true;
          
          const entityStr = typeof userEntity === 'string' ? userEntity.toUpperCase() : '';
          if (!item.restrictedTo.includes(entityStr)) {
            return false;
          }
        }
        return true;
      })
      .map(item => {
        if (item.sub) {
          return { ...item, sub: filterNavItems(item.sub) };
        }
        return item;
      });
  };

  const filteredSidebarConfig = filterNavItems(sidebarConfig);

  const renderContentDesktop = (
    <>
      <Box component="div" className="toggle-menu">
        <IconButton size="medium" onClick={() => handleCollapseMenu()} className="menu-icon"><MenuIcon fontSize="inherit" /></IconButton>
      </Box>

      <Box component="div" className={`sidebar ${isCollapsibleMenu ? "collapse-sidebar" : ""}`} ref={ref} onMouseOver={mouseLeaveAndOver} onMouseLeave={mouseLeaveAndOver}>
        <Box component="div" className="sidebar-header">
          <Box
            component={RouterLink}
            to="/3/app/dashboard"
          >
            <Logo />
          </Box>
        </Box>
        <NavSection navConfig={filteredSidebarConfig} component="div" className="sidebar-list" />
      </Box>
    </>
  );

  const renderContentMobile = (
    <Box
      sx={{
        height: "100vh",
        overflowY: "auto"
      }}
    >
      <Box>
        <Box
          component={RouterLink}
          to="/3/app/dashboard"
        >
          <Logo />
        </Box>
      </Box>

      <Box sx={{ mb: 3 }}>
        <Link underline="none" component={RouterLink} to={prefixV3 + "/profile"}>
          <AccountStyle>
            <Avatar
              src={"https://cdn-icons-png.flaticon.com/512/3135/3135789.png"}
              alt="avatar"
            />
            <Box sx={{ ml: 2 }}>
              <Typography variant="subtitle2" sx={{ color: "text.primary" }}>
                {parseEmail(userSession.user.email)}
              </Typography>
              <Typography variant="body2" sx={{ color: "text.secondary" }}>
                Finance
              </Typography>
            </Box>
          </AccountStyle>
        </Link>
      </Box>

      <NavSection navConfig={filteredSidebarConfig} />

      <Box sx={{ flexGrow: 1 }} />
    </Box>
  );

  return (
    <RootStyle className={`docs-nav-wrapper ${isCollapsibleMenu ? "collapse-menu" : ""}`}>
      {
        hidden ?
          renderContentDesktop
          :
          <Drawer
            open={isOpenSidebar}
            onClose={onCloseSidebar}
            anchor="left"
            PaperProps={{
              sx: { width: DRAWER_WIDTH },
            }}
          >
            {renderContentMobile}
          </Drawer>
      }
    </RootStyle >
  );
}
